import React from 'react'
import PropTypes from 'prop-types'
import GooglePlayDownloadButton from 'commons/js/ui/GooglePlayDownloadButton'
import AppleStoreDownloadButton from 'commons/js/ui/AppleStoreDownloadButton'
import { Copy, Flex, Box } from '@elparking/components'
import { devices } from '@elparking/utils'

const soNoMobile = () => !devices.isAndroid() && !devices.isIphone()

function getBadget (isAndroid, isIphone) {
    if (isAndroid()) {
        return <GooglePlayDownloadButton height='35px' />
    }
    if (isIphone()) {
        return <AppleStoreDownloadButton />
    }
    return <Box>
        <Box as='span' pr='16px'><GooglePlayDownloadButton/></Box>
        <AppleStoreDownloadButton />
    </Box>
}

BannerDownloadApp.propTypes = {
    text: PropTypes.object,
    isAndroid: PropTypes.func,
    isIphone: PropTypes.func,
}

BannerDownloadApp.defaultProps = {
    isAndroid: devices.isAndroid,
    isIphone: devices.isIphone,
}

function BannerDownloadApp ({text, isAndroid, isIphone}) {
    return (
        <Flex flexDirection={soNoMobile() ? 'column' : 'row'} justifyContent='center' alignItems='center' background='accent40' py='16px' px='12px'>
            <Copy padding={soNoMobile() ? '0 0 8px 0' : '0 16px 0 0'} fontSize={soNoMobile() ? 'xxSmall' : 'small'}>
                {text}
            </Copy>
            {getBadget(isAndroid, isIphone)}
        </Flex>
    )
}

export default BannerDownloadApp
